module.exports = __webpack_public_path__ + "img/012.58026faa.png";